export default __webpack_public_path__ + "static/media/spotify.e0da40d8.svg";